import {Component} from '@angular/core';
import {SessionService} from '../../../../services/session';
import {StudiosService} from '../../../../services/studios';
import {NavController, NavParams} from 'ionic-angular';
import {StudioPage} from '../../shared/studio/studio';
import {LocationsService} from '../../../../services/locations';

@Component({
  selector: 'page-gyms',
  templateUrl: 'gyms.html',
})
export class GymsPage {
  studioPage = StudioPage;

  display: 'favorites' | 'trending';

  constructor(
    public sessionService: SessionService,
    public studiosService: StudiosService,
    private locationsService: LocationsService,
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
    this.display = navParams.data.display;
  }

  gyms = [];

  ionViewDidEnter() {
    this.gyms = [];
    let gymsRef: any[];
    if (this.display === 'trending') {
      // defaults to favorites
      gymsRef = this.sessionService.user.trending_gyms;
    } else {
      gymsRef = this.sessionService.user.favorite_gyms;
    }
    if (gymsRef.length > 0) {
      this.studiosService.studios.forEach((studio) => {
        if (gymsRef.indexOf(studio.id) > -1) {
          this.gyms.push(studio);
        }
      });
    }
  }

  goToStudio(studio) {
    this.navCtrl.push(this.studioPage, {studioInfo: studio});
  }

  getDisplay(): string {
    if (this.display === 'trending') {
      this.capitalizeFirstLetter(this.locationsService.translate('studio')) + 's virtuales';
    } else {
      return 'Favoritos';
    }
  }

  capitalizeFirstLetter(string) {
    return string[0].toUpperCase() + string.slice(1);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/gyms/gyms.ts